import { restClient } from 'libs/restClient';
import { UPDATE_PAYMENT, SHOW_NOTICE } from 'actions/types';
import { notifyMessages } from 'helpers/NotifyHelper';
import { setPaymentArgs } from 'helpers/ArgsHelper';

export const updatePayment = request => async dispatch => {
  try {
    const url = `/invoices/${request.invoice.id}`;
    const body = setPaymentArgs(request);
    const response = await restClient.put(url, body);

    dispatch({ type: UPDATE_PAYMENT, payload: response.data.data });
    dispatch({
      type: SHOW_NOTICE,
      payload: notifyMessages.paymentUpdatedSuccessfully
    });
  } catch (e) {
    dispatch({
      type: SHOW_NOTICE,
      payload: notifyMessages.cantUpdateRequest
    });
  }
};



// WEBPACK FOOTER //
// ./src/actions/payments.js